const getters = {
  name: (state) => state.user.name,
  token: (state) => state.user.token,
  userInfo: (state) => state.user.userInfo,
}
export default getters
